import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { FormattedMessage } from "react-intl";

/**
 * @typedef {object} Props
 * @property {import("@raiden/library/types/Post").Post | null} review
 * @property {boolean} isOpen
 * @property {() => void} onClose
 */

/**
 * @param {Props} props
 */
export function ReviewModal({ review, isOpen, onClose }) {
  const translate = useTranslate();

  return (
    <Modal size="4xl" isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          <FormattedMessage
            defaultMessage="Détail de l'avis de {title}"
            values={{ title: translate(review?.current_revision?.title) }}
          />
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <Text whiteSpace="pre-line">
            {translate(review?.current_revision?.summary)}
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button variant="outline" onClick={onClose}>
            <FormattedMessage defaultMessage="Fermer" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
